export var COPY_BENEFIT_FREE_DELIVERY = "Free delivery on eligible items or orders";
export var COPY_BENEFIT_MEMBER_PRICING = "Member-only pricing";
export var COPY_BENEFIT_RETURNS = "365 day returns for change of mind returns on products sold by Catch";
export var COPY_BENEFIT_EXCLUSIVE_DEALS = "Weekly exclusive member deals";
export var COPY_BENEFIT_FLYBUYS_POINTS = "$2 = 2 points with Flybuys";